import React from 'react'
import Buoi1 from './Buoi1';
import { useParams } from 'react-router-dom';
import { NotFound } from 'AppRoute';

const buoiList = {
    "1": <Buoi1 />
}

export default function Lop1() {
    const { buoi } = useParams();
    if (!(buoi in buoiList)) {
        return <NotFound />
    }

    return buoiList[buoi];
}
